import { company_name } from "@/i18n/variables";

const debtors = {
	add_button: "Debiteur toevoegen",
	add_debtor: {
		form: {
			common_email_address: {
				label: "E-mailadres algemene zaken",
				placeholder: `info@${company_name}.nl`,
			},
			company_address_description:
				"In deze sectie kunt u de adresgegevens van het aan te maken bedrijf invullen.",
			/* ---------------------------- COMPANY ADDRESS INFO -------------------------- */
			company_address_title: "Adresgegevens",
			company_communication_description:
				"In deze sectie kunt u de communicatie voorkeuren van het aan te maken bedrijf invullen.",

			/* ------------------------- COMPANY COMMUNICATION INFO ---------------------- */
			company_communication_title: "Communicatie voorkeuren",
			company_info_description: "In deze sectie kunt u een bedrijf toevoegen aan de debiteur.",
			/* ------------------------------ COMPANY INFO ------------------------------ */
			company_info_title: "Bedrijf toevoegen",
			company_invoice_description:
				"In deze sectie kunt u de facturatiegegevens van het aan te maken bedrijf invullen.",
			/* ---------------------------- COMPANY INVOICE INFO -------------------------- */
			company_invoice_title: "Facturatiegegevens",
			debtor_account_description:
				"Hier kunt u bestaande gebruikers toevoegen aan een debiteur, of een nieuwe gebruiker uitnodigen en deze direct toevoegen.",

			/* ------------------------------- ADD ACCOUNT ------------------------------ */
			debtor_account_title: "Gebruiker toevoegen",
			debtor_groups: {
				label: "Debiteurgroepen",
				placeholder: "Resellers",
			},
			debtor_info_description: "Debiteur informatie",
			/* ------------------------------- DEBTOR INFO ------------------------------ */
			debtor_info_title: "Debiteur Informatie",
			debtor_name: {
				label: "Debiteurnaam",
				placeholder: `${company_name}`,
			},
			debtor_type: {
				business: "Zakelijk",
				label: "Type",
				placeholder: "Zakelijk",
				private: "Particulier",
			},
			different_invoice: {
				label: "Facturatie gegevens afwijkend?",
				no: "Nee",
				yes: "Ja",
			},
			email_address: {
				label: "E-mailadres",
				placeholder: `info@${company_name}.nl`,
			},
			emergency_number: {
				label: "Noodnummer",
				placeholder: "0612345678",
			},
			internal_note: {
				label: "Interne notitie",
				placeholder: "Interne notitie",
			},
			invoices_email_address: {
				label: "E-mailadres offertes",
				placeholder: `administratie@${company_name}.nl`,
			},
			kvk_number: {
				label: "KVK-nummer",
				placeholder: "12345678",
			},
			username: {
				label: "Gebruikersnaam",
				placeholder: `${company_name}`,
			},
		},
		title: "Debiteur toevoegen",
	},
	edit_debtor: {
		form: {
			company_address_description:
				"In deze sectie kunt u de facturatiegegevens van het bedrijf bewerken.",
			company_communication_description:
				"In deze sectie kunt u de adresgegevens van het bedrijf bewerken.",
			company_info_description: "In deze sectie kunt u het bedrijf van de debiteur bewerken.",
			company_info_title: "Bedrijf bewerken",
			company_invoice_description:
				"In deze sectie kunt u de facturatiegegevens van het bedrijf bewerken.",
		},
		title: "Debiteur bewerken",
	},
	import_button: "Debiteur importeren",
	membership_type: {
		business: "Business",
		label: "Selecteer type debiteur",
		private: "Private",
	},
	table: {
		company: "Bedrijf",
		debtor_code: "Debiteurnummer",
		details: "Details",
		family_name: "Achternaam",
		given_name: "Voornaam",
		middle_name: "Tussenvoegsel",
		name: "Naam",
		type: "Type",
	},
	title: "Debiteuren",
};

export default debtors;
